<div class="mobile-menu">
  <markant-icon-button
    id="mobile-menu"
    data-cy="mobile-menu"
    class="menu-button-mobile"
    colorScheme="dark"
    icon="m_menu"
    (click)="togglePopover()"
  >
  </markant-icon-button>

  <markant-popover
    id="mobile-menu-popover"
    data-cy="mobile-menu-popover"
    placement="bottom-end"
    class="mobile-menu-popover"
    for="mobile-menu"
    [visible]="showPopover"
    (backdrop)="closePopover()"
  >
    <markant-list class="mobile-menu-dropdown">
      <markant-platform-user-menu class="mobile"></markant-platform-user-menu>
      <markant-list-divider></markant-list-divider>
      <ng-container *ngFor="let route of routes">
        <markant-list-item
          *ngIf="!route.external; else externalRoute"
          class="mobile-menu-dropdown-list-item"
          data-markant-close
          [text]="route.label | transloco"
          [routerLink]="route.route ?? undefined"
          [routerLinkActive]="['active']"
          [routerLinkActiveOptions]="{ exact: route.route === '/' }"
          (click)="closePopover()"
        >
        </markant-list-item>
        <ng-template #externalRoute>
          <a [href]="route.route" target="_blank">
            <markant-list-item
              class="mobile-menu-dropdown-list-item"
              [text]="route.label | transloco"
            >
              <markant-icon
                icon="m_external-link"
                slot="markant-list-item-trailing"
              ></markant-icon>
            </markant-list-item>
          </a>
        </ng-template>
      </ng-container>
      <markant-list-divider></markant-list-divider>
      <markant-list-item
        [text]="'userMenu.logout' | transloco"
        data-markant-close
        (click)="logout()"
      >
      </markant-list-item>
    </markant-list>
  </markant-popover>
</div>
